export const headers = [
  { name: 'Almanac No.', id: 'identification_number' },
  { name: 'Aton Name', id: 'name' },
  { name: 'Aton Type', id: 'aton_type' },
  { name: 'Location', id: 'operational_area' },
  { name: 'Category', id: 'category' },
  { name: 'Incidents', id: 'has_incidents', sortable: false },
  { name: 'Last Visit Date', id: 'latest_visit_date' }
];
